import { TravelExpense } from "./travel-expense";

export class TravelLine {
    id: number = 0;
    source_customer_id:number = 0; 
    source_customer:string = ''; 
    source_customer_address_id:number = 0; 
    source_customer_address:string = ''; 
    target_customer_id:number = 0; 
    target_customer:string = ''; 
    target_customer_address_id:number = 0; 
    target_customer_address:string = ''; 
    time:number = 0; 
    gas:number = 0; 
    gas_extra:number = 0; 
    ton_real:number = 0; 
    ticket:number = 0; 
    meters:number = 0; 
    ton:number = 0; 
    line:number = 1; 
    product_id:number = 0; 
    product_name:string = ''; 
    order_id:number = 0; 
    travel_id:number = 0; 
    presentation_id:number = 0; 
    presentation_name:string = ''; 
    unit_type_presentation:string = 'Sencillo'; 
    delivery_date:Date = new Date(); 
    travelExpenses:TravelExpense[] = [];
    hasExpenses:boolean = false;
    num_lines:number = 1;
    market_price:number = 0;
}
